import { render, staticRenderFns } from "./BxLcdjList.vue?vue&type=template&id=f1295622&scoped=true&"
import script from "./BxLcdjList.vue?vue&type=script&lang=js&"
export * from "./BxLcdjList.vue?vue&type=script&lang=js&"
import style0 from "./BxLcdjList.vue?vue&type=style&index=0&id=f1295622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1295622",
  null
  
)

export default component.exports